// Invoice Action Type

// Get List of Invoices

export const GET_INVOICE_LIST = "GET_INVOICE_LIST";
export const GET_INVOICE_LIST_SUCCESS = "GET_INVOICE_LIST_SUCCESS";
export const GET_INVOICE_LIST_ERROR = "GET_INVOICE_LIST_ERROR";

// Get Invoice Single PDF invoice

export const GET_INVOICE_SINGLE_PDF = "GET_INVOICE_SINGLE_PDF";
export const GET_INVOICE_SINGLE_PDF_SUCCESS = "GET_INVOICE_SINGLE_PDF_SUCCESS";
export const GET_INVOICE_SINGLE_PDF_ERROR = "GET_INVOICE_SINGLE_PDF_ERROR";

// get Single Invoice Data

export const GET_SINGLE_INVOICE_DATA = "GET_SINGLE_INVOICE_DATA";
export const GET_SINGLE_INVOICE_DATA_SUCCESS =
  "GET_SINGLE_INVOICE_DATA_SUCCESS";
export const GET_SINGLE_INVOICE_DATA_ERROR = "GET_SINGLE_INVOICE_DATA_ERROR";

// Create Single Invoice Data

export const CREATE_SINGLE_INVOICE_DATA = "CREATE_SINGLE_INVOICE_DATA";
export const CREATE_SINGLE_INVOICE_DATA_SUCCESS =
  "CREATE_SINGLE_INVOICE_DATA_SUCCESS";
export const CREATE_SINGLE_INVOICE_DATA_ERROR =
  "CREATE_SINGLE_INVOICE_DATA_ERROR";

// Update Single Invoice Data

export const UPDATE_SINGLE_INVOICE_DATA = "UPDATE_SINGLE_INVOICE_DATA";
export const UPDATE_SINGLE_INVOICE_DATA_SUCCESS =
  "UPDATE_SINGLE_INVOICE_DATA_SUCCESS";
export const UPDATE_SINGLE_INVOICE_DATA_ERROR =
  "UPDATE_SINGLE_INVOICE_DATA_ERROR";

// Search Single Customer Invoice List

export const SEARCH_SINGLE_CUSTOMER_INVOICE_LIST =
  "SEARCH_SINGLE_CUSTOMER_INVOICE_LIST";
export const SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_SUCCESS =
  "SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_SUCCESS";
export const SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_ERROR =
  "SEARCH_SINGLE_CUSTOMER_INVOICE_LIST_ERROR";

// Search Job Invoice List (single-job Invoices tab)

export const SEARCH_JOB_INVOICE_LIST = "SEARCH_JOB_INVOICE_LIST";
export const SEARCH_JOB_INVOICE_LIST_SUCCESS =
  "SEARCH_JOB_INVOICE_LIST_SUCCESS";
export const SEARCH_JOB_INVOICE_LIST_ERROR = "SEARCH_JOB_INVOICE_LIST_ERROR";

// Resend Invoice Email

export const RESEND_INVOICE_EMAIL = "RESEND_INVOICE_EMAIL";
export const RESEND_INVOICE_EMAIL_SUCCESS = "RESEND_INVOICE_EMAIL_SUCCESS";
export const RESEND_INVOICE_EMAIL_ERROR = "RESEND_INVOICE_EMAIL_ERROR";

// Send Invoice Email

export const SEND_INVOICE_EMAIL = "SEND_INVOICE_EMAIL";
export const SEND_INVOICE_EMAIL_SUCCESS = "SEND_INVOICE_EMAIL_SUCCESS";
export const SEND_INVOICE_EMAIL_ERROR = "SEND_INVOICE_EMAIL_ERROR";

// void Invoice

export const VOID_INVOICE = "VOID_INVOICE";
export const VOID_INVOICE_SUCCESS = "VOID_INVOICE_SUCCESS";
export const VOID_INVOICE_ERROR = "VOID_INVOICE_ERROR";

// re-invoice (void current invoice + generate a new one using today)

export const REINVOICE = "REINVOICE";
export const REINVOICE_SUCCESS = "REINVOICE_SUCCESS";
export const REINVOICE_ERROR = "REINVOICE_ERROR";
// Get Invoice Status List

export const GET_INVOICE_STATUS_LIST = "GET_INVOICE_STATUS_LIST";
export const GET_INVOICE_STATUS_LIST_SUCCESS =
  "GET_INVOICE_STATUS_LIST_SUCCESS";
export const GET_INVOICE_STATUS_LIST_ERROR = "GET_INVOICE_STATUS_LIST_ERROR";

// Add New Invoice Status
export const ADD_NEW_INVOICE_STATUS = "ADD_NEW_INVOICE_STATUS";
export const ADD_NEW_INVOICE_STATUS_SUCCESS = "ADD_NEW_INVOICE_STATUS_SUCCESS";
export const ADD_NEW_INVOICE_STATUS_ERROR = "ADD_NEW_INVOICE_STATUS_ERROR";

// Delete Invoice Status
export const DELETE_INVOICE_STATUS = "DELETE_INVOICE_STATUS";
export const DELETE_INVOICE_STATUS_SUCCESS = "DELETE_INVOICE_STATUS_SUCCESS";
export const DELETE_INVOICE_STATUS_ERROR = "DELETE_INVOICE_STATUS_ERROR";

// Update Invoice Status
export const UPDATE_INVOICE_STATUS = "UPDATE_INVOICE_STATUS";
export const UPDATE_INVOICE_STATUS_SUCCESS = "UPDATE_INVOICE_STATUS_SUCCESS";
export const UPDATE_INVOICE_STATUS_ERROR = "UPDATE_INVOICE_STATUS_ERROR";

// Get Invoice Payment Method List
export const GET_INVOICE_PAYMENT_METHOD_LIST =
  "GET_INVOICE_PAYMENT_METHOD_LIST";
export const GET_INVOICE_PAYMENT_METHOD_LIST_SUCCESS =
  "GET_INVOICE_PAYMENT_METHOD_LIST_SUCCESS";
export const GET_INVOICE_PAYMENT_METHOD_LIST_ERROR =
  "GET_INVOICE_PAYMENT_METHOD_LIST_ERROR";

// Add New Invoice Payment Method
export const ADD_NEW_INVOICE_PAYMENT_METHOD = "ADD_NEW_INVOICE_PAYMENT_METHOD";
export const ADD_NEW_INVOICE_PAYMENT_METHOD_SUCCESS =
  "ADD_NEW_INVOICE_PAYMENT_METHOD_SUCCESS";
export const ADD_NEW_INVOICE_PAYMENT_METHOD_ERROR =
  "ADD_NEW_INVOICE_PAYMENT_METHOD_ERROR";

// Delete Invoice Payment Method
export const DELETE_INVOICE_PAYMENT_METHOD = "DELETE_INVOICE_PAYMENT_METHOD";
export const DELETE_INVOICE_PAYMENT_METHOD_SUCCESS =
  "DELETE_INVOICE_PAYMENT_METHOD_SUCCESS";
export const DELETE_INVOICE_PAYMENT_METHOD_ERROR =
  "DELETE_INVOICE_PAYMENT_METHOD_ERROR";

// Update Invoice Payment Method
export const UPDATE_INVOICE_PAYMENT_METHOD = "UPDATE_INVOICE_PAYMENT_METHOD";
export const UPDATE_INVOICE_PAYMENT_METHOD_SUCCESS =
  "UPDATE_INVOICE_PAYMENT_METHOD_SUCCESS";
export const UPDATE_INVOICE_PAYMENT_METHOD_ERROR =
  "UPDATE_INVOICE_PAYMENT_METHOD_ERROR";

// Master Invoice List
export const GET_MASTER_INVOICE_LIST = "GET_MASTER_INVOICE_LIST";
export const GET_MASTER_INVOICE_LIST_SUCCESS =
  "GET_MASTER_INVOICE_LIST_SUCCESS";
export const GET_MASTER_INVOICE_LIST_ERROR = "GET_MASTER_INVOICE_LIST_ERROR";

// MasterInvoice Data Single
export const GET_MASTER_INVOICE_SINGLE_DATA = "GET_MASTER_INVOICE_SINGLE_DATA";
export const GET_MASTER_INVOICE_SINGLE_DATA_SUCCESS =
  "GET_MASTER_INVOICE_SINGLE_DATA_SUCCESS";
export const GET_MASTER_INVOICE_SINGLE_DATA_ERROR =
  "GET_MASTER_INVOICE_SINGLE_DATA_ERROR";

// Get CRMIT Invoice PDF Single
export const GET_CRMIT_INVOICE_PDF_SINGLE = "GET_CRMIT_INVOICE_PDF_SINGLE";
export const GET_CRMIT_INVOICE_PDF_SINGLE_SUCCESS =
  "GET_CRMIT_INVOICE_PDF_SINGLE_SUCCESS";
export const GET_CRMIT_INVOICE_PDF_SINGLE_ERROR =
  "GET_CRMIT_INVOICE_PDF_SINGLE_ERROR";

// Invoice Item List
export const GET_INVOICE_ITEM_LIST = "GET_INVOICE_ITEM_LIST";
export const GET_INVOICE_ITEM_LIST_SUCCESS = "GET_INVOICE_ITEM_LIST_SUCCESS";
export const GET_INVOICE_ITEM_LIST_ERROR = "GET_INVOICE_ITEM_LIST_ERROR";

///masterinvoice/list/customer
export const GET_MASTER_INVOICE_LIST_CUSTOMER =
  "GET_MASTER_INVOICE_LIST_CUSTOMER";
export const GET_MASTER_INVOICE_LIST_CUSTOMER_SUCCESS =
  "GET_MASTER_INVOICE_LIST_CUSTOMER_SUCCESS";
export const GET_MASTER_INVOICE_LIST_CUSTOMER_ERROR =
  "GET_MASTER_INVOICE_LIST_CUSTOMER_ERROR";
///invoiceactivitylog/search
export const SEARCH_INVOICE_ACTIVITY_LOG = "SEARCH_INVOICE_ACTIVITY_LOG";
export const SEARCH_INVOICE_ACTIVITY_LOG_SUCCESS =
  "SEARCH_INVOICE_ACTIVITY_LOG_SUCCESS";
export const SEARCH_INVOICE_ACTIVITY_LOG_ERROR =
  "SEARCH_INVOICE_ACTIVITY_LOG_ERROR";
///invoiceitem/search
export const SEARCH_INVOICE_ITEMS_LIST = "SEARCH_INVOICE_ITEMS_LIST";
export const SEARCH_INVOICE_ITEMS_LIST_SUCCESS =
  "SEARCH_INVOICE_ITEMS_LIST_SUCCESS";
export const SEARCH_INVOICE_ITEMS_LIST_ERROR =
  "SEARCH_INVOICE_ITEMS_LIST_ERROR";
///jobinvoiceitemtemplate/list
export const GET_JOB_INVOICE_ITEM_TEMPLATE_LIST =
  "GET_JOB_INVOICE_ITEM_TEMPLATE_LIST";
export const GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_SUCCESS =
  "GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_SUCCESS";
export const GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_ERROR =
  "GET_JOB_INVOICE_ITEM_TEMPLATE_LIST_ERROR";
///jobinvoiceitemtemplate/data/
export const GET_JOB_INVOICE_ITEM_TEMPLATE_DATA =
  "GET_JOB_INVOICE_ITEM_TEMPLATE_DATA";
export const GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_SUCCESS =
  "GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_SUCCESS";
export const GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_ERROR =
  "GET_JOB_INVOICE_ITEM_TEMPLATE_DATA_ERROR";
///jobinvoiceitemtemplate/search
export const SEARCH_JOB_INVOICE_ITEM_TEMPLATE =
  "SEARCH_JOB_INVOICE_ITEM_TEMPLATE";
export const SEARCH_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS =
  "SEARCH_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS";
export const SEARCH_JOB_INVOICE_ITEM_TEMPLATE_ERROR =
  "SEARCH_JOB_INVOICE_ITEM_TEMPLATE_ERROR";
///jobinvoiceitemtemplate/create
export const CREATE_JOB_INVOICE_ITEM_TEMPLATE =
  "CREATE_JOB_INVOICE_ITEM_TEMPLATE";
export const CREATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS =
  "CREATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS";
export const CREATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR =
  "CREATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR";
///jobinvoiceitemtemplate/update
export const UPDATE_JOB_INVOICE_ITEM_TEMPLATE =
  "UPDATE_JOB_INVOICE_ITEM_TEMPLATE";
export const UPDATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS =
  "UPDATE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS";
export const UPDATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR =
  "UPDATE_JOB_INVOICE_ITEM_TEMPLATE_ERROR";
///jobinvoiceitemtemplate/delete
export const DELETE_JOB_INVOICE_ITEM_TEMPLATE =
  "DELETE_JOB_INVOICE_ITEM_TEMPLATE";
export const DELETE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS =
  "DELETE_JOB_INVOICE_ITEM_TEMPLATE_SUCCESS";
export const DELETE_JOB_INVOICE_ITEM_TEMPLATE_ERROR =
  "DELETE_JOB_INVOICE_ITEM_TEMPLATE_ERROR";
